export default __webpack_public_path__ + "static/media/reebokCover.1fe40d11.jpg";